import Mock from 'mockjs'

Mock.Random.extend({
  status: function (date) {
    let status = ['pending', 'error', 'pass', 'finish']
    return this.pick(status)
  }
})

const organizerMatchInfo = Mock.mock({
  data: {
    title: '@ctitle',
    sponsor: '@ctitle',
    'files|2-3': [
      {
        title: '@ctitle',
        url: '@url',
        icon: 'fa fa-file-text'
      }
    ],
    'match_status|7-9': [
      {
        title: '@ctitle',
        statu: '@status'
      }
    ]
  }
})

export default [
  {
    path: '/api/organizerInfo',
    type: 'get',
    response: config => {
      return {
        status: 'success',
        data: organizerMatchInfo
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/mocks/modules/organizerWorkbench.js